import { render, staticRenderFns } from "./BulmaCheckboxDate.vue?vue&type=template&id=6f67a91b&scoped=true"
import script from "./BulmaCheckboxDate.vue?vue&type=script&lang=js"
export * from "./BulmaCheckboxDate.vue?vue&type=script&lang=js"
import style0 from "./BulmaCheckboxDate.vue?vue&type=style&index=0&id=6f67a91b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f67a91b",
  null
  
)

export default component.exports